import type { ReactNode, CSSProperties } from 'react';
import type { Branding } from '../types';

interface ShellProps {
  branding: Branding | null;
  children: ReactNode;
  /** Drops header and footer chrome entirely, to maximize vertical space for
   * content that needs it (the liveness capture frame on tall phones, where
   * the Amplify-rendered button was getting pushed below the fold even with
   * a merely-shrunk header — branding was already established on the
   * consent screen the user just came from, so it isn't needed here). */
  compact?: boolean;
}

const DEFAULT_COLOR = '#C60000';

export default function Shell({ branding, children, compact = false }: ShellProps) {
  const primaryColor = branding?.primaryColor || DEFAULT_COLOR;
  const style = { '--brand-color': primaryColor } as CSSProperties;

  return (
    <div className="shell" style={style}>
      {!compact && (
        <header className="shell-header">
          {branding?.logoUrl ? (
            <img src={branding.logoUrl} alt={branding.brandName || 'Logo'} className="shell-logo" />
          ) : (
            <span className="shell-brand-name">{branding?.brandName || 'Inmutable'}</span>
          )}
        </header>
      )}
      <main className={compact ? 'shell-content shell-content--compact' : 'shell-content'}>{children}</main>
      {!compact && (
        <footer className="shell-footer">
          <span>Verificación de identidad segura — powered by Inmutable</span>
        </footer>
      )}
    </div>
  );
}
